import {recalculateLayoutOnce, recalculateLayoutEveryPage} from '../utils/calculateCssVars';

window.addEventListener( 'load', function () {
  recalculateLayoutOnce();
  recalculateLayoutEveryPage();
} );
window.addEventListener( 'resize', function () {
  recalculateLayoutOnce();
  recalculateLayoutEveryPage();
} );
